<mat-toolbar color="accent">{{ isEdit ? 'Edit' : 'Insert' }} HTML</mat-toolbar>

<mat-dialog-content>
  <div
    class="grid h-full grid-cols-1 grid-rows-2 gap-4 md:grid-cols-2 md:grid-rows-1"
  >
    <form class="mb-[-22px] mt-[28px] flex min-h-0 min-w-0" [formGroup]="form">
      <mat-form-field
        class="flex min-h-0 w-full flex-1 flex-col"
        subscriptSizing="dynamic"
      >
        <mat-label>HTML</mat-label>
        <textarea
          matInput
          class="h-full min-h-full resize-none overflow-auto font-mono"
          formControlName="html"
          rows="12"
          spellcheck="false"
          placeholder="Paste the HTML provided by your marketing company..."
        ></textarea>
        <mat-hint>
          Scripts and other unsafe content will not be displayed
        </mat-hint>
      </mat-form-field>
    </form>

    <div class="flex min-h-0 min-w-0 flex-col gap-1">
      <span class="text-[11px] font-medium opacity-70">Preview</span>
      <pt-raw-html-preview
        class="min-h-0 flex-1 rounded border border-solid border-gray-300 p-2"
        [html]="preview$ | async"
      />
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="form.invalid"
      (click)="save()"
    >
      Save
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
